import * as React from "react";
import { select } from "d3-selection";
const defaultRenderElement = ({ selectionRef }) => (<g ref={selectionRef}/>);
/**
 * Apply props to component.
 *
 * @param {Object} component
 * The component instance the props will be applied to
 *
 * @param {Object} props
 * Props that will be applied to the component
 */
export const applyPropsToComponent = (component, props) => {
    Object.keys(props).forEach(k => {
        if (!(k in component)) {
            throw Error(`Can't apply prop "${k}" to component`);
        }
        component[k](props[k]);
    });
    return component;
};
export class D3Component extends React.Component {
    constructor() {
        super(...arguments);
        this.selectionRef = el => {
            if (el) {
                this.selection = select(el);
            }
            else {
                this.selection = null;
            }
        };
    }
    componentDidMount() {
        // call the component with the passed data attached to it
        if (this.selection) {
            this.selection.datum(this.props.datum).call(this.props.component);
        }
    }
    componentDidUpdate() {
        if (this.selection) {
            this.selection.datum(this.props.datum).call(this.props.component);
        }
    }
    render() {
        const { renderElement } = this.props;
        const childProps = {
            selectionRef: this.selectionRef
        };
        return renderElement
            ? React.Children.only(renderElement(childProps))
            : defaultRenderElement(childProps);
    }
}



// WEBPACK FOOTER //
// ./src/sszvis-components/D3Component.tsx